import { Box, Typography } from '@mui/material';

import { runSummaryAgentReportStyles } from './styles/runSummaryAgentReportStyles';

export default function RunSummaryAgentGraphSection({ title, subtitle, items = [] }) {
  return (
    <Box sx={runSummaryAgentReportStyles.graphSection}>
      <Typography variant="subtitle2" sx={runSummaryAgentReportStyles.sectionTitle}>
        {title}
      </Typography>
      <Typography variant="caption" color="text.secondary" display="block" mb={1.5}>
        {subtitle}
      </Typography>

      {items.length > 0 ? (
        <Box sx={runSummaryAgentReportStyles.graphRows}>
          {items.map((item) => (
            <Box key={item.label} sx={runSummaryAgentReportStyles.graphRow}>
              <Box sx={runSummaryAgentReportStyles.graphRowHeader}>
                <Typography
                  variant="body2"
                  noWrap
                  title={item.label}
                  sx={runSummaryAgentReportStyles.graphLabel}
                >
                  {item.label}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {item.meta}
                </Typography>
              </Box>
              <Box sx={runSummaryAgentReportStyles.graphBarTrack}>
                <Box
                  sx={runSummaryAgentReportStyles.graphBarSegment(
                    item.primaryPercent,
                    item.primaryColor,
                  )}
                />
                <Box
                  sx={runSummaryAgentReportStyles.graphBarSegment(
                    item.secondaryPercent,
                    item.secondaryColor,
                  )}
                />
              </Box>
              <Box sx={runSummaryAgentReportStyles.graphLegend}>
                <Typography variant="caption" sx={{ color: item.primaryColor, fontWeight: 700 }}>
                  {item.primaryLabel}: {item.primaryValue}
                </Typography>
                <Typography variant="caption" sx={{ color: item.secondaryColor, fontWeight: 700 }}>
                  {item.secondaryLabel}: {item.secondaryValue}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      ) : (
        <Typography variant="body2" color="text.secondary">
          No data available for this graph.
        </Typography>
      )}
    </Box>
  );
}
